import React, { useState } from "react";
import { CgMenuLeftAlt } from "react-icons/cg";
import {
  FaBell,
  FaUserCircle,
  FaUser,
  FaSignOutAlt,
  FaChevronDown,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../store/slices/auth";

export default function HeaderNav({ onMenuClick }) {
  const { profile } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showCard, setShowCard] = useState(false);

  const userName = profile?.name || "Admin";
  const userEmail = profile?.email || "";

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();

      setShowCard(false);

      navigate("/login", {
        replace: true,
      });
    } catch (error) {
      console.log("Logout error:", error);
    }
  };

  return (
    <header className="header">

      {/* ================= LEFT ================= */}
      <div className="header-left">

        <button
          type="button"
          className="menu-btn"
          onClick={onMenuClick}
          aria-label="Toggle menu"
        >
          <CgMenuLeftAlt size={25} />
        </button>

        <div className="header-welcome">
          <span className="welcome-small">
            Welcome back,
          </span>

          <h6 className="welcome-text">
            {userName}
          </h6>
        </div>

      </div>


      {/* ================= RIGHT ================= */}
      <div className="header-icons">

        {/* Notification */}
        <div className="header-icon notification-icon">
          <FaBell size={17} />


        </div>


        {/* Profile */}
        <div
          className={`profile-wrapper ${showCard ? "active" : ""}`}
          onMouseEnter={() => setShowCard(true)}
          onMouseLeave={() => setShowCard(false)}
        >

          <div className="profile-trigger">

            <div className="profile-avatar">
              <FaUserCircle size={25} />
            </div>

            <div className="profile-name">
              <span>
                {userName}
              </span>

              <small>
                Administrator
              </small>
            </div>

            <FaChevronDown
              className={`profile-arrow ${showCard ? "rotate" : ""
                }`}
              size={11}
            />

          </div>


          {/* ================= PROFILE CARD ================= */}
          {showCard && (
            <div
              className="profile-hover-card"
              onMouseEnter={() => setShowCard(true)}
              onMouseLeave={() => setShowCard(false)}
            >

              {/* Profile header */}
              <div className="profile-card-header">

                <div className="profile-large-avatar">
                  <FaUserCircle size={48} />
                </div>

                <div className="profile-user-info">
                  <h6>
                    {userName}
                  </h6>

                  <span>
                    {userEmail || "No email available"}
                  </span>
                </div>

              </div>


              <div className="profile-divider" />


              {/* Profile menu */}
              <div className="profile-menu">

                <Link
                  to="/admin/profile"
                  className="profile-menu-item"
                  onClick={() => setShowCard(false)}
                >
                  <span className="profile-menu-icon">
                    <FaUser size={13} />
                  </span>

                  <span>
                    My Profile
                  </span>
                </Link>


                <button
                  type="button"
                  className="profile-menu-item logout-item"
                  onClick={handleLogout}
                >
                  <span className="profile-menu-icon logout-icon">
                    <FaSignOutAlt size={13} />
                  </span>

                  <span>
                    Logout
                  </span>
                </button>

              </div>

            </div>
          )}

        </div>

      </div>

    </header>
  );
}